import { Component } from 'react';

// Older open tabs may request a route chunk removed by a newer deployment.
export default class RouteLoadBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (!this.state.error) return this.props.children;
    const downloadFailed = /ChunkLoadError|Loading (?:CSS )?chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(`${this.state.error?.name} ${this.state.error?.message}`);
    return <div role="alert" className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-6 text-center">
      <h1 className="text-lg font-semibold">Die Seite konnte nicht geladen werden.</h1>
      <p className="text-sm text-[#636366]">{downloadFailed ? 'Ein Teil der Anwendung konnte nicht geladen werden. Bitte lade die Seite erneut.' : 'Beim Öffnen der Seite ist ein Fehler in der Anwendung aufgetreten. Bitte lade die Seite erneut.'} Ungespeicherte Eingaben können dabei verloren gehen.</p>
      <button type="button" className="rounded-xl bg-black px-5 py-3 text-white" onClick={() => window.location.reload()}>Seite neu laden</button>
    </div>;
  }
}
